import {SyncUIActDecorator} from '@gongxigames/framework/slotV2/fsm/acts/decorators/SyncUIActDecorator';
import {FeatureEventData, slotStore} from '@gongxigames/framework/slotV2/globals';
import {listenUIDisabled} from '@gongxigames/framework/slotV2/ui/acts/utils';

export class PickBonusUIAct extends SyncUIActDecorator {
    public execute(): void {
        listenUIDisabled(this);

        this.emitter.emit('General.disableSpinButton');
        this.emitter.emit('UI.updateUIElementsState', 'PickBonusUIState');

        this.emitter.on('Game.command.round.featureStopped', (data: FeatureEventData) => {
            if (data.type === 'pickBonus') {
                slotStore.batchUpdate({
                    feature_type: null
                });
                this.onExecuted?.();
            }
        });
    }

    getName(): string {
        return 'PickBonusUIAct';
    }
}